<div class="share-link-page">

  <header class="recuvery-site-header">

    <div class="recuvery-site-header__inner">

      <a class="recuvery-site-header__logo" href="https://recuvery.com" target="_blank" rel="noopener noreferrer">

        <img src="assets/images/img/logo-main.png" alt="Recuvery" />

      </a>

      <div class="recuvery-site-header__contact">

        <a class="contact-item" href="tel:+18339047001" [attr.aria-label]="'Call ' + supportPhone">

          <span class="contact-icon" aria-hidden="true">

            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">

              <path d="M5.5 4.5h3l2 5-2.2 1.4a12.5 12.5 0 0 0 5.8 5.8L15.5 14l5 2v3a1.5 1.5 0 0 1-1.6 1.5A15.5 15.5 0 0 1 3 6.1 1.5 1.5 0 0 1 4.5 4.5Z" />

            </svg>

          </span>

          <span>{{ supportPhone }}</span>

        </a>

        <a class="contact-item" [href]="'mailto:' + supportEmail" [attr.aria-label]="'Email ' + supportEmail">

          <span class="contact-icon" aria-hidden="true">

            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">

              <rect x="3.5" y="5.5" width="17" height="13" rx="1.5" />

              <path d="M4.5 7.5 12 12.5l7.5-5" />

            </svg>

          </span>

          <span>{{ supportEmail }}</span>

        </a>

      </div>

    </div>

  </header>



  <div class="share-link-page__content">

    <div class="share-link-page__center">

      <ng-container *ngIf="!isPaymentSuccessful; else paymentSuccessScreen">

        <div class="share-link-layout">

          <div class="share-link-card" [class.share-link-card--loading]="isLoading">

            <ng-container *ngIf="isLoading; else shareLinkContent">

              <section class="share-intro share-intro--shimmer">
                <div class="shimmer shimmer-text shimmer-text--welcome"></div>
                <div class="shimmer shimmer-text shimmer-text--headline"></div>
                <div class="shimmer shimmer-text shimmer-text--subline"></div>

                <div class="share-payment-action">
                  <div class="shimmer shimmer-button"></div>
                  <div class="share-secure-banner share-secure-banner--shimmer">
                    <div class="shimmer shimmer-secure-badge"></div>
                    <div class="shimmer shimmer-text shimmer-text--secure-msg"></div>
                  </div>
                </div>
              </section>

              <aside class="plan-info-box plan-info-box--shimmer">
                <div class="plan-info-box__summary">
                  <div class="shimmer shimmer-text shimmer-text--xs shimmer-text--center"></div>
                  <div class="shimmer shimmer-text shimmer-text--amount shimmer-text--center"></div>
                  <div class="shimmer shimmer-text shimmer-text--badge shimmer-text--center"></div>
                </div>

                <div class="plan-info-box__details">
                  <div class="shimmer-plan-row" *ngFor="let _ of [1, 2, 3, 4]">
                    <div class="shimmer shimmer-text shimmer-text--row-label"></div>
                    <div class="shimmer shimmer-text shimmer-text--row-value"></div>
                  </div>
                </div>

                <div class="plan-info-box__customer">
                  <div class="shimmer-plan-row" *ngFor="let _ of [1, 2, 3, 4]">
                    <div class="shimmer shimmer-text shimmer-text--row-label"></div>
                    <div class="shimmer shimmer-text shimmer-text--row-value"></div>
                  </div>
                </div>
              </aside>

            </ng-container>



            <ng-template #shareLinkContent>

              <section class="share-intro">

                <p class="welcome-text">Hello {{ practiceName || businessName }}</p>

                <h1 class="headline">
                  One Quick Step to Complete Your Payment.
                </h1>

                <p class="next-payment" *ngIf="nextPaymentDate">
                  Next Payment Date: {{ nextPaymentDate | date: 'MMM d, y' }}
                </p>

                <div class="share-payment-action">
                  <button
                    type="button"
                    class="pay-button mt-4"
                    [disabled]="isProcessingPayment"
                    (click)="payBusinessShare()"
                  >
                    {{ isProcessingPayment ? 'Processing...' : 'Pay Now Credit/Debit Card' }}
                  </button>

                  <div class="share-secure-banner">
                    <div class="share-secure-badge">
                      <span class="share-secure-badge__icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                          <rect x="5" y="11" width="14" height="10" rx="2" />
                          <path d="M8 11V8a4 4 0 0 1 8 0v3" />
                        </svg>
                      </span>
                      <div class="share-secure-badge__text">
                        <strong>SECURE</strong>
                        <span>SSL ENCRYPTION</span>
                      </div>
                    </div>
                    <p class="share-secure-banner__message">
                      Your payment details are secured and confidential with advanced encryption and SSL protection.
                    </p>
                  </div>

                </div>

              </section>



              <aside class="plan-info-box">

                <div class="plan-info-box__summary">
                  <p class="plan-info-box__label">Recuvery Fee</p>
                  <h2 class="plan-info-box__amount">${{ chargeAmount | number: '1.2-2' }}</h2>
                  <!-- <span class="status-badge status-badge--dark" [ngClass]="statusBadgeClass">{{ paymentStatus }}</span> -->
                </div>

                <div class="plan-info-box__details">
                  <div class="plan-info-row" *ngIf="planAmount !== null">
                    <span>Plan Amount</span>
                    <strong>${{ planAmount | number: '1.2-2' }}</strong>
                  </div>

                  <div class="plan-info-row" *ngIf="planDuration">

                    <span>Plan Duration</span>

                    <strong>{{ planDuration }}</strong>

                  </div>

                  <div class="plan-info-row" *ngIf="monthlyPayment !== null">

                    <span>Monthly Payment</span>

                    <strong>${{ monthlyPayment | number: '1.2-2' }}</strong>

                  </div>

                  <div class="plan-info-row" *ngIf="enrollmentDate">
                    <span>Enrollment Date</span>
                    <strong>{{ enrollmentDate | date: 'MM/dd/yyyy' }}</strong>
                  </div>
                </div>

                <div class="plan-info-box__customer">
                  <div class="plan-info-row">
                    <span>Account ID</span>
                    <strong class="text-uppercase">{{ contractCode || accountId }}</strong>
                  </div>
                  <div class="plan-info-row">
                    <span>Customer Name</span>
                    <strong>{{ patientName }}</strong>
                  </div>
                  <div class="plan-info-row">
                    <span>Customer Email</span>
                    <strong>{{ patientEmail || 'N/A' }}</strong>
                  </div>
                  <div class="plan-info-row">
                    <span>Customer Phone</span>
                    <strong>{{ patientPhone || 'N/A' }}</strong>
                  </div>
                 
                </div>

              </aside>

            </ng-template>

          </div>

        </div>

      </ng-container>



      <ng-template #paymentSuccessScreen>

        <div class="share-payment-success d-flex flex-column align-items-center justify-content-center text-center">

          <div class="share-payment-success__icon mb-3">&#10003;</div>

          <h3 class="mb-2">Payment Successful</h3>

          <p class="mb-0">

            Your recovery fee payment to Recuvery LLC has been processed successfully

          </p>

        </div>

      </ng-template>

    </div>

  </div>



  <footer class="recuvery-site-footer">

    <div class="recuvery-site-footer__inner">

      <p>Copyright &copy; {{ copyrightYear }} Recuvery. All Rights Reserved.</p>

    </div>

  </footer>

</div>


